import Menu from '../../data/menu.json';
import Menu_Ai from '../../data/menu_ai.json';
import { BR_ENABLED } from '../../constants/businessRegistration';
import MenuAdmin from '../../data/menu_admin';
import MenuEBoothAB from '../../data/menu_eBoothAB';
import BonusUI from '../../data/bonusui';
import ExtraMenu from '../../data/menu_extra';
import {authentication} from './authentication.js';
import Vue from 'vue';

const userMenuData = process.env.VUE_APP_EMP_ENV_NAME === 'AI'
  ? Menu_Ai.data
  : BR_ENABLED
  ? Menu.data
  : Menu.data.filter((item) => !String(item.path || '').startsWith('/businessDocuments'));
const userBottomMenuData = process.env.VUE_APP_EMP_ENV_NAME === 'AI'
  ? Menu_Ai.bottomMenuItems
  : BR_ENABLED
  ? (Menu.bottomMenuItems || [])
  : (Menu.bottomMenuItems || []).filter((item) => !String(item.path || '').startsWith('/businessDocuments'));

const state = {
  data: userMenuData,
  userdata: userMenuData,
  admindata: MenuAdmin.data,
  eBoothABdata:MenuEBoothAB.data,
  extraMenu: ExtraMenu.data,
  megamenu: BonusUI.data,
  bottomMenuItems: userBottomMenuData,
  searchData: [],
  togglesidebar: true,
  activeoverlay : false,
  searchOpen : false,
  customizer: '',
  customizerTitle: '',
  hideRightArrowRTL: false,
  hideLeftArrowRTL: true,
  hideRightArrow: true,
  hideLeftArrow: true,
  width: 0,
  height: 0,
  margin: 0,
  menuWidth: 0,
};

// getters
const getters = {
  
};

// mutations
const mutations = {

  loginAsUser: (state) => {
    state.data = state.userdata;
    // HideMenuByAccessRight(state)
  },
  loginAsAdmin: (state) => {
    state.data = state.admindata;
    HideMenuByAccessRight(state)
  },
  loginAsEBoothAB: (state) => {
    if (process.env.VUE_APP_EMP_ENV_NAME === 'AI') return
    state.data = state.eBoothABdata;
    // HideMenuByAccessRight(state)
  },
  opensidebar: (state) => {
    state.togglesidebar = !state.togglesidebar;
    if (window.innerWidth < 991) {
      state.activeoverlay = true;
      if (state.togglesidebar) {
        // document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    } else {
      state.activeoverlay = false;
      document.body.style.overflow = '';
    }
  },
  resizetoggle: (state) => {
    if (window.innerWidth < 1199) {
      state.togglesidebar = false;
      // state.activeoverlay = true
      document.body.style.overflow = '';
    } else {
      state.togglesidebar = true;
      // state.activeoverlay = false
      document.body.style.overflow = '';
    }
  },
  searchTerm: (state, term) => {

    let items = [];
    var searchval = term.toLowerCase();
    state.data.filter(menuItems => {
      
      if (menuItems.title) {
        if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false;
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
            subItems.icon = menuItems.icon;
            items.push(subItems);
          }
          if (!subItems.children) return false;
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(searchval)) {
              suSubItems.icon = menuItems.icon;
              items.push(suSubItems);
            }
          });
        });
        state.searchData = items;
      }
    });
  },
  setBonusNavActive: (state, item) => {
    if (!item.active) {
      state.megamenu.forEach(a => {
        if (state.megamenu.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setNavActive: (state, item) => {
    if (!item.active) {
      state.data.forEach(a => {
        if (state.data.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setActiveRoute: (state, item) => {
    state.data.filter(menuItem => {
      if (menuItem !== item)
        menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  },
  appendExtraMenuItem:(state) => {
      //Get permitted extra menu item of user
      var user = authentication.state.user
     
      if('extraPermissions' in user){
          var UserExtraPermissions = user.extraPermissions
          var UserExtraMenu = state.extraMenu.filter(x=> 
          x.permissionType.some(y => UserExtraPermissions.itemName.includes(y)
          && !x.IsHide)
        )
         
        state.data = state.data.concat(UserExtraMenu)
      }
      
  },
  // Update eBoothABdata SalesLead badgeValue from unread count
  updateEBoothABBadge: (state, unreadCount) => {
    // Update in eBoothABdata
    const salesLeadMenuItemEBooth = state.eBoothABdata.find(item => 
      item.path === '/salesLead/all' ||
      item.path === '/salesLead/default' ||
      item.title === 'lbl_EMPBE_SalesLead_SalesLead'
    );
    
    // Also update in current active menu data (state.data)
    const salesLeadMenuItem = state.data.find(item => 
      item.path === '/salesLead/all' ||
      item.path === '/salesLead/default' ||
      item.title === 'lbl_EMPBE_SalesLead_SalesLead'
    );
    
    const updateBadge = (menuItem) => {
      if (menuItem) {
        if (unreadCount > 0) {
          // Update badge value with unread count
          Vue.set(menuItem, 'badgeValue', unreadCount.toString());
          // Ensure badgeType is set
          if (!menuItem.badgeType) {
            Vue.set(menuItem, 'badgeType', 'light-primary');
          }
        } else {
          // Clear badge value if unread is 0
          Vue.set(menuItem, 'badgeValue', '');
        }
      }
    };
    
    // Update both to keep them in sync
    updateBadge(salesLeadMenuItemEBooth);
    updateBadge(salesLeadMenuItem);
  },
  // 广告宣传侧栏角标：优先已驳回（!），其次未提交数量；皆无则不显示
  updateAdBadge: (state, { toBeSubmittedCount = 0, rejectedCount = 0 }) => {
    const isAdMenuItem = (item) => (
      item.path === '/AdvertismentInfoCenter/default'
      || item.title === 'lbl_EMPBE_AdInfoCenter'
    );

    const menuItems = [
      ...(state.data || []),
      ...(state.userdata || []),
      ...(state.eBoothABdata || []),
    ].filter(isAdMenuItem);

    const uniqueItems = [...new Set(menuItems)];

    uniqueItems.forEach((menuItem) => {
      if (rejectedCount > 0) {
        Vue.set(menuItem, 'badgeValue', '!');
        Vue.set(menuItem, 'badgeType', 'light-danger');
      } else if (toBeSubmittedCount > 0) {
        Vue.set(menuItem, 'badgeValue', String(toBeSubmittedCount));
        Vue.set(menuItem, 'badgeType', 'light-primary');
      } else {
        Vue.set(menuItem, 'badgeValue', '');
        Vue.set(menuItem, 'badgeType', '');
      }
    });
  },
};

// actions
const actions = {
  opensidebar: (context, term) => {
    context.commit('opensidebar', term);
  },
  resizetoggle: (context, term) => {
    context.commit('resizetoggle', term);
  },
  setBonusNavActive: (context, term) => {
    context.commit('setBonusNavActive', term);
  },
  searchTerm: (context, term) => {
    context.commit('searchTerm', term);
  },
  setNavActive: (context, item) => {
    context.commit('setNavActive', item);
  },
  setActiveRoute: (context, item) => {
    context.commit('setActiveRoute', item);
  },
  appendExtraMenuItem: (context, item) => {
    context.commit('appendExtraMenuItem', item);
  },
  // Update eBoothAB badge from unread store
  updateEBoothABBadgeFromUnread: ({ commit, rootState }, type) => {
    // Access unread count directly from state by type
    const unreadCount = rootState.unread[type]?.unread || 0;
    commit('updateEBoothABBadge', unreadCount);
  },
  updateAdBadgeFromUnread: ({ commit, rootState }) => {
    const counts = rootState.unread.advertisment || {};
    commit('updateAdBadge', {
      toBeSubmittedCount: counts.toBeSubmittedCount || 0,
      rejectedCount: counts.rejectedCount || 0,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function  HideMenuByAccessRight(state)  {
  
  var UserPermissions = authentication.state.user.Permissions
  
  if(!UserPermissions || authentication.state.user.IsFullAccess){
    return
  }

  state.data = state.data.filter(item => !item.AccessIDs ||

    item.AccessIDs.split(',').some(AccessID => UserPermissions.includes(AccessID))
  )
}